var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"productCardTop"},[_c('img',{attrs:{"src":"https://png.pngtree.com/png-clipart/20201208/original/pngtree-luxury-auto-car-service-company-logo-concept-stock-illustration-png-image_5536092.jpg","alt":""}}),_c('v-btn',{},[_vm._v("Battery")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }